<app-shared-dialog 
    class="technical_dialog"
    title=" "
    [options]="{
        size: 'large',
        titleIcon: 'ai-volta-icon',
        titleIconColor: 'primary',
        confirmText: 'common.proceed'|translate | uppercase,
        cancelText: 'common.cancel'|translate | uppercase,
        confirmButtonStyle: 'ai',
        confirmIcon: 'procced-arrow',
        confirmIconPosition: 'end'
    }" (confirm)="save()" (cancel)="close()">
<div class="dialog-content">
    <div class="dialog-content-title">
        <span>{{ 'quotations_and_orders.prompt.create_order_from' | translate }}</span>
        <span class="ai-title">
            {{ 'quotations_and_orders.prompt.unstructured_data' | translate }}
        </span>
    </div>
    <div class="dialog-content">
        <div class="standard-input">
            <textarea [(ngModel)]="unstructuredData" class="textarea-input" name="unstructured-data" id="unstructured-data" [placeholder]="'quotations_and_orders.prompt.unstructured_data_placeholder' | translate"></textarea>
        </div>
        <div class="dialog-content-upload-file-title">
            {{ 'quotations_and_orders.prompt.upload_file' | translate }}
        </div>
        <div
            class="dialog-content-upload-file"
            [class.drag-over]="isDragging"
            role="button"
            tabindex="0"
            [attr.aria-label]="'quotations_and_orders.prompt.upload_files' | translate"
            (click)="fileInput.click()"
            (keydown.enter)="fileInput.click()"
            (keydown.space)="$event.preventDefault(); fileInput.click()"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
        >
            <div class="upload-file-label">
                <ui-svg-icon svgIcon="upload-icon" size="medium"></ui-svg-icon>
                <div class="upload-file-label-text">
                    <span>{{ 'quotations_and_orders.prompt.upload_files' | translate }}</span>
                    <span class="upload-file-label-text-description">{{ 'quotations_and_orders.prompt.upload_description' | translate }}</span>
                </div>
            </div>
            <div class="upload-file-container">
                <ui-button
                    [type]="'tertiary'"
                    [label]="'quotations_and_orders.prompt.browse_files' | translate"
                    (click)="$event.stopPropagation(); fileInput.click()"
                ></ui-button>
                <input 
                    type="file" 
                    #fileInput
                    multiple
                    accept=".xls,.xlsx,.csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                    (change)="onFilesSelected($event)"
                    style="display: none;"
                />
          </div>
        </div>
        <div class="uploaded-files-container">
            <div class="badge" *ngFor="let file of selectedFiles let index = index">
                <ui-svg-icon svgIcon="file-icon" size="medium"></ui-svg-icon>
                <span [title]="file.filename">{{ file.filename }}</span>
                <button (click)="removeFile(index)">
                    <ui-svg-icon svgIcon="close" size="medium"></ui-svg-icon>
                </button>
            </div>
        </div>
    </div>
</div>
</app-shared-dialog>
